// eslint-disable-next-line no-restricted-syntax
import React from 'react';
import {useLocation, useNavigate} from 'react-router';
import {Box, Typography, useTheme} from '@mui/material';

import CustomImage from '@/components/atoms/CustomImage/CustomImage';

type NavigationItemProps = {
  icon: string;
  label: string;
  path?: string;
  iconActive?: string;
};

export const NavigationItem: React.FC<NavigationItemProps> = ({
  icon,
  label,
  path,
  iconActive,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const onClick = () => {
    path && navigate(path);
  };
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        background: 'none',
        border: 'none',
        padding: 0,
      }}>
      <CustomImage
        alt={`${label} icon`}
        height={28}
        width={28}
        url={location.pathname === path ? iconActive || '' : icon || ''}
        styleProps={{
          aspectRatio: '1',
          objectFit: 'contain',
          objectPosition: 'center',
          width: 28,
        }}
      />
      <Typography
        variant="caption"
        sx={{
          color:
            location.pathname === path
              ? theme.palette.text.primary
              : theme.palette.divider,
          whiteSpace: 'nowrap',
          textAlign: 'center',
          letterSpacing: '0.4%',
          fontSize: '10px',
          fontWeight: 500,
          lineHeight: '100%',
          marginTop: '4px',
        }}>
        {label}
      </Typography>
    </Box>
  );
};
